<template>
  <el-form label-width="120px">
    <el-form-item label="Current Branch">
      <el-input
        v-model="asset.branch.label"
        readonly
      />
    </el-form-item>

    <el-form-item
      label="New Branch"
      required
    >
      <el-select
        v-model="event.branch"
        class="w-100"
        clearable
        value-key="id"
        :loading="isLoadingBranches"
      >
        <el-option
          v-for="branch in branches"
          :key="branch.id"
          :disabled="branch.id === asset.branch.id"
          :label="branch.label"
          :value="branch"
        />
      </el-select>
    </el-form-item>

    <el-form-item label="Note">
      <el-input
        v-model="note.content"
        type="textarea"
      />
    </el-form-item>

    <el-form-item label="Attachments">
      <FileUpload
        drag
        multiple
      />
    </el-form-item>
  </el-form>
</template>

<script>
import FileUpload from '@/components/FileUpload'
import { TYPE_TRANSFER } from '@/plugins/sdk/resources/Asset/Event'

export default {
  components: {
    FileUpload
  },
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isLoadingBranches: false,
      branches: [],
      event: Object.assign(new this.$sdk.asset_event(), {
        type: TYPE_TRANSFER
      }),
      note: new this.$sdk.note()
    }
  },
  mounted () {
    this
      .event
      .notes
      .push(this.note)

    this
      .asset
      .events
      .push(this.event)

    this.loadBranches()
  },
  methods: {
    async loadBranches () {
      this.isLoadingBranches = true

      try {
        this.branches = await this
          .$sdk
          .dictionary_businessbranch
          .list(request => {
            request.limit = 100
          })
      } finally {
        this.isLoadingBranches = false
      }
    }
  }
}
</script>
